"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureCode = exports.BundleStatus = exports.BundlePricing = exports.BundleItemType = exports.BusinessModel = exports.PermissionScope = exports.UserActivity = exports.SourceClassification = exports.PushNotification = exports.Program = exports.MuxVideoStatus = exports.InfluencerPayment = exports.LatestPurchase = exports.AndroidSubscriptionNotification = exports.Campaign = exports.Email = exports.UserStorage = exports.Gift = exports.Post = exports.Influencer = exports.User = exports.Exercise = exports.PortalUser = exports.Worker = exports.Message = void 0;
var bundle_1 = require("./bundle");
Object.defineProperty(exports, "BundleItemType", { enumerable: true, get: function () { return bundle_1.BundleItemType; } });
Object.defineProperty(exports, "BundlePricing", { enumerable: true, get: function () { return bundle_1.BundlePricing; } });
Object.defineProperty(exports, "BundleStatus", { enumerable: true, get: function () { return bundle_1.BundleStatus; } });
Object.defineProperty(exports, "FeatureCode", { enumerable: true, get: function () { return bundle_1.FeatureCode; } });
var businessModel_1 = require("./businessModel");
Object.defineProperty(exports, "BusinessModel", { enumerable: true, get: function () { return businessModel_1.BusinessModel; } });
var custom_permissions_1 = require("./custom-permissions");
Object.defineProperty(exports, "PermissionScope", { enumerable: true, get: function () { return custom_permissions_1.PermissionScope; } });
var source_classification_enum_1 = require("./source-classification.enum");
Object.defineProperty(exports, "SourceClassification", { enumerable: true, get: function () { return source_classification_enum_1.SourceClassification; } });
var user_activity_enum_1 = require("./user-activity.enum");
Object.defineProperty(exports, "UserActivity", { enumerable: true, get: function () { return user_activity_enum_1.UserActivity; } });
// used for inter-process communication inside the Node cluster
var Message = {
    Type: {
        Log: { name: "Log", value: 1 },
        Post: { name: "Post", value: 2 },
        fromValue: fromValue,
    },
};
exports.Message = Message;
var Worker = {
    Interval: {
        Small: { name: "Short", value: 3 },
        Medium: { name: "Medium", value: 5 },
        Large: { name: "Large", value: 7 },
        fromValue: fromValue,
    },
};
exports.Worker = Worker;
var PortalUser = {
    Role: {
        Administrator: { name: "Super Admin", value: 1 },
        Moderator: { name: "Admin", value: 2 },
        Influencer: { name: "Creator", value: 3 },
        ContentEditor: { name: "Content Editor", value: 4 },
        fromValue: fromValue,
    },
};
exports.PortalUser = PortalUser;
var Exercise = {
    Type: {
        Custom: { name: "Custom", value: 1 },
        Single: { name: "Single", value: 2 },
        Multiple: { name: "Multiple", value: 3 },
        YouTube: { name: "YouTube", value: 4 },
        Product: { name: "Product", value: 5 },
        Nutrition: { name: "Nutrition", value: 6 },
        fromValue: fromValue,
    },
};
exports.Exercise = Exercise;
var Program = {
    Type: {
        Program: { name: "Program", value: 0 },
        Collection: { name: "Collection", value: 3 },
        fromValue: fromValue,
    },
    SortingBehaviour: {
        Top: { name: "Top", value: "top" },
        Bottom: { name: "Bottom", value: "bottom" },
    },
    PublishingBehaviour: {
        Top: { name: "Top", value: "top" },
        Bottom: { name: "Bottom", value: "bottom" },
    },
    ContentStructure: {
        Dayweek: { name: "Weekly", value: "dayweek" },
        Days: { name: "Daily", value: "days" },
        Sequential: { name: "Series", value: "sequential" },
    },
    AccessType: {
        Exclusive: { name: "Exclusive", value: "exclusive" },
        Premium: { name: "Premium", value: "premium" },
        PremiumExclusive: {
            name: "Premium & Exclusive",
            value: "premium-exclusive",
        },
    },
};
exports.Program = Program;
var MuxVideoStatus = {
    PROCESSING: {
        STARTED: "PROCESSING_STARTED",
        ENCODE_FINISHED: "PROCESSING_ENCODE_FINISHED",
        FINISHED: "PROCESSING_FINISHED",
        ERRORED: "PROCESSING_ERROR",
    },
    UPLOAD_URL: {
        CREATED: "UPLOAD_URL_CREATED",
    },
    UPLOAD: {
        STARTED: "UPLOAD_STARTED",
        CANCELLED: "UPLOAD_CANCELLED",
        FINISHED: "UPLOAD_FINISHED",
    },
    ERROR: "ERROR",
};
exports.MuxVideoStatus = MuxVideoStatus;
var User = {
    Channel: {
        Developers: { name: "Developers", value: 1 },
        BetaTesters: { name: "BetaTesters", value: 2 },
        fromValue: fromValue,
    },
    Activity: {
        WorkoutComplete: { name: "WorkoutComplete", value: 1 },
        WorkoutRate: { name: "WorkoutRate", value: 2 },
        WorkoutView: { name: "WorkoutView", value: 3 },
        WorkoutBegin: { name: "WorkoutBegin", value: 4 },
        ConsumerOpen: { name: "ConsumerOpen", value: 5 },
        ConsumerClose: { name: "ConsumerClose", value: 6 },
        ExerciseView: { name: "ExerciseView", value: 7 },
        MediaView: { name: "MediaView", value: 8 },
        StoryView: { name: "StoryView", value: 9 },
        CancelSubscription: { name: "CancelSubscription", value: 10 },
        InfluencerFollow: { name: "InfluencerFollow", value: 11 },
        InfluencerUnfollow: { name: "InfluencerUnfollow", value: 12 },
        WorkoutMark: { name: "WorkoutMark", value: 13 },
        WorkoutUnmark: { name: "WorkoutUnmark", value: 14 },
        WorkoutSetReminder: { name: "WorkoutSetReminder", value: 15 },
        WorkoutDeleteReminder: { name: "WorkoutDeleteReminder", value: 16 },
        WorkoutAddToFavourites: { name: "WorkoutAddToFavourites", value: 17 },
        WorkoutRemoveFromFavourites: {
            name: "WorkoutRemoveFromFavourites",
            value: 18,
        },
        fromValue: fromValue,
    },
    Upload: {
        ProfileThumbnail: { name: "ProfileThumbnail", value: 1 },
        fromValue: fromValue,
    },
};
exports.User = User;
var Influencer = {
    Type: {
        Creator: { name: "Creator", value: 1 },
        Dummy: { name: "Dummy", value: 2 },
        fromValue: fromValue,
    },
    Mode: {
        OnHold: { name: "On Hold", value: 1 },
        Onboarding: { name: "Onboarding", value: 2 },
        ReadyToGoLive: { name: "Ready to go live", value: 3 },
        Live: { name: "Live", value: 4 },
        RunOff: { name: "Run Off", value: 5 },
        Deactivated: { name: "Deactivated", value: 6 },
        fromValue: fromValue,
    },
    PaymentMethod: {
        None: { name: "None", value: null },
        StripeConnect: { name: "StripeConnect", value: 1 },
        PayPal: { name: "PayPal", value: 2 },
        WireTransfer: { name: "WireTransfer", value: 3 },
    },
    Tier: {
        None: { name: "None", value: null },
        First: { name: "1 - Managed", value: 1 },
        Second: { name: "2 - PBC - Premium", value: 2 },
        Thrid: { name: "3 - PBC - Standard", value: 3 },
        Fourth: { name: "4 - Self-Serve", value: 4 },
        Fifth: { name: "5 - Internal (PB Employee)", value: 5 },
        Sixth: { name: "6 - Junk", value: 6 },
    },
};
exports.Influencer = Influencer;
var Post = {
    Type: {
        Question: { name: "Question", value: 1 },
        Feedback: { name: "Feedback", value: 2 },
        Testimonial: { name: "Testimonial", value: 3 },
        WorkoutComment: { name: "WorkoutComment", value: 4 },
        WorkoutSuggestion: { name: "WorkoutSuggestion", value: 5 },
        InsightSuggestion: { name: "InsightSuggestion", value: 6 },
        DiscoverySuggestion: { name: "DiscoverySuggestion", value: 7 },
        ShakeForFeedback: { name: "ShakeForFeedback", value: 8 },
        fromValue: fromValue,
    },
    Status: {
        New: { name: "New", value: 1 },
        Seen: { name: "Seen", value: 2 },
        Archived: { name: "Archived", value: 3 },
        Reported: { name: "Reported", value: 4 },
        fromValue: fromValue,
    },
};
exports.Post = Post;
/**
 * Gift
 * WorkoutFromConsumer - Paying Consumer gifting a workout via url.
 * WorkoutFromGuest - Guest (Non-Paying Consumer) unlocking a workout both for himself and the redeeming guest.
 */
var Gift = {
    Type: {
        WorkoutFromConsumer: { name: "WorkoutFromConsumer", value: 1 },
        WorkoutFromGuest: { name: "WorkoutFromGuest", value: 2 },
        WorkoutFromInfluencer: { name: "WorkoutFromInfluencer", value: 3 },
        fromValue: fromValue,
    },
};
exports.Gift = Gift;
/**
 * UserStorage
 * GiftedWorkout - Given or rather sent by Consumer.
 * AwardedWorkout - Given by Fitner as an award for something (referred 10 new users).
 * SavedWorkout - saved by consumer (sticky, bought, something like that).
 */
var UserStorage = {
    Type: {
        GiftedWorkout: { name: "GiftedWorkout", value: 1 },
        AwardedWorkout: { name: "AwardedWorkout", value: 2 },
        SavedWorkout: { name: "SavedWorkout", value: 3 },
        fromValue: fromValue,
    },
};
exports.UserStorage = UserStorage;
/**
 * Email
 * PortalUserActivated - Sent to PortalUser on first activation.
 * PortalUserFirstLogin - Sent to PortalUser on first successful login.
 * InfluencerOnboardingProfile - Sent to Influencer on first 100% complete profile save.
 * InfluencerOnboardingWorkouts - Sent to Influencer on
 * InfluencerNoticeTwoWeeks - Influencer hasn't posted in 2 weeks.
 * InfluencerNoticeFourWeeks - Influencer hasn't posted in 4 weeks.
 * ConsumerWelcome - Consumer logged in for the first time.
 * ConsumerTrialStart - Consumer started subscription trial period.
 * ConsumerTrialOngoing - Consumer has been in trial for 3 days.
 * ConsumerTrialFail - Consumer hasn't converted from trial to paying user.
 * ConsumerTrialSuccess - Consumer converted from trial to paying user.
 */
var Email = {
    Type: {
        PortalUserActivated: { name: "PortalUserActivated", value: 1 },
        PortalUserFirstLogin: { name: "PortalUserFirstLogin", value: 2 },
        InfluencerOnboardingProfile: {
            name: "InfluencerOnboardingProfile",
            value: 3,
        },
        InfluencerOnboardingWorkouts: {
            name: "InfluencerOnboardingWorkouts",
            value: 4,
        },
        InfluencerNoticeTwoWeeks: { name: "InfluencerNoticeTwoWeeks", value: 5 },
        InfluencerNoticeFourWeeks: { name: "InfluencerNoticeFourWeeks", value: 6 },
        ConsumerWelcome: { name: "ConsumerWelcome", value: 7 },
        ConsumerTrialStart: { name: "ConsumerTrialStart", value: 8 },
        ConsumerTrialOngoing: { name: "ConsumerTrialOngoing", value: 9 },
        ConsumerTrialFail: { name: "ConsumerTrialFail", value: 10 },
        ConsumerTrialSuccess: { name: "ConsumerTrialSuccess", value: 11 },
        fromValue: fromValue,
    },
};
exports.Email = Email;
/**
 * Campaign
 * Legacy - Legacy object; no action necessary.
 * New - New object; condition checking and potential action required.
 * Active - Object satisfied conditions and is currently in processing by other entities; no not disturb.
 * Done - Object no longer target of Campaign.
 */
var Campaign = {
    Status: {
        Legacy: { name: "Legacy", value: 1 },
        New: { name: "New", value: 2 },
        Active: { name: "Active", value: 3 },
        Done: { name: "Done", value: 4 },
        fromValue: fromValue,
    },
};
exports.Campaign = Campaign;
var AndroidSubscriptionNotification = {
    Type: {
        Recovered: { name: "Recovered", value: 1 },
        Renewed: { name: "Renewed", value: 2 },
        Cancelled: { name: "Cancelled", value: 3 },
        Purchased: { name: "Purchased", value: 4 },
        OnHold: { name: "OnHold", value: 5 },
        InGracePeriod: { name: "InGracePeriod", value: 6 },
        Restarted: { name: "Restarted", value: 7 },
        PriceChangeConfirmed: { name: "PriceChangeConfirmed", value: 8 },
        Deferred: { name: "Deferred", value: 9 },
        fromValue: fromValue,
    },
};
exports.AndroidSubscriptionNotification = AndroidSubscriptionNotification;
var LatestPurchase = {
    Platform: {
        Playbook: { name: "Playbook", value: 0 },
        IOS: { name: "IOS", value: 1 },
        Android: { name: "Android", value: 2 },
        Stripe: { name: "Stripe", value: 3 },
    },
    PaymentPeriod: {
        Monthly: { name: "Monthly", value: 0 },
        Quarterly: { name: "Quarterly", value: 1 },
        Annual: { name: "Annual", value: 2 },
        Daily: { name: "Daily", value: 3 },
    },
    PaymentState: {
        FreeTrial: { name: "FreeTrial", value: 0 },
        Paid: { name: "Paid", value: 1 },
        Renewing: { name: "Renewing", value: 2 },
        Expired: { name: "Expired", value: 3 },
        Refunded: { name: "Refunded", value: 4 },
        BillingFailure: { name: "BillingFailure", value: 5 },
        Failure: { name: "Failure", value: 6 },
    },
};
exports.LatestPurchase = LatestPurchase;
var InfluencerPayment = {
    Status: {
        // newly created payment request
        New: { name: "New", value: 1 },
        // paid payment request, money successfully sent
        Done: { name: "Done", value: 2 },
        // currently in processing or awaiting completion
        Pending: { name: "Pending", value: 3 },
        // missing Creator's Stripe / bank account details
        MissingInfo: { name: "MissingInfo", value: 4 },
        // last attempt at payment failed, for example inadequate funds
        Failed: { name: "Failed", value: 5 },
        // when we decide we won't actually pay something, archive without paying
        Cancelled: { name: "Cancelled", value: 6 },
        fromValue: fromValue,
    },
};
exports.InfluencerPayment = InfluencerPayment;
//[tc] this is a way to retrieve the full enum when you only have the value
function fromValue(value) {
    var keys = Object.keys(this);
    for (var i = 0; i < keys.length; i++) {
        if (this[keys[i]] !== null && this[keys[i]].value == value) {
            return this[keys[i]];
        }
    }
}
var PushNotification = {
    Type: {
        NewWorkout: { name: "NewWorkout", value: 1 },
        LivestreamStarted: { name: "LivestreamStarted", value: 2 },
        CreatorGeneric: { name: "CreatorGeneric", value: 3 },
        NewProgram: { name: "NewProgram", value: 4 },
        NewStory: { name: "NewStory", value: 5 },
        ReferredFriendJoined: { name: "ReferredFriendJoined", value: 6 },
        ReferralRewardRedeemable: { name: "ReferralRewardRedeemable", value: 7 },
        CreatorPostedInCommunity: { name: "CreatorPostedInCommunity", value: 8 },
        ReplyToYourPost: { name: "ReplyToYourPost", value: 9 },
        ReactionToYourPost: { name: "ReactionToYourPost", value: 10 },
        ReactionToYourComment: { name: "ReactionToYourComment", value: 11 },
        NewPostInYourCommunity: { name: "NewPostInYourCommunity", value: 12 },
        WorkoutCommentAdded: { name: "WorkoutCommentAdded", value: 13 },
        StartSellingOtp: {
            name: "StartSellingOtp",
            value: 14,
        },
        AlreadySellingOtp: {
            name: "AlreadySellingOtp",
            value: 15,
        },
        WorkoutAwarded: { name: "WorkoutAwarded", value: 16 },
        LongVideoIsReady: { name: "LongVideoIsReady", value: 17 },
        DirectMessage: { name: "DirectMessage", value: 18 },
        fromValue: fromValue,
    },
};
exports.PushNotification = PushNotification;
